<template>
  <div id="ruleDom">
    <h2 style="font-size: 32px;font-family: 'SimSun';font-weight: 1000">深圳市司法鉴定协会章程</h2>
    <div v-if="page == 0">
      <div class="general">
        <span>第一章</span>
        <span>总则</span>
      </div>
      <div class="content">
        <span class="content-title">第一条</span>
        <span>本团体名称：深圳市司法鉴定协会。</span>
      </div>
      <div class="content">
        <span class="content-title">第二条</span>
        <span>本团体的性质：由全市司法鉴定机构、司法鉴定人以及从事其他鉴定领域工作的单位和人员自愿组成的专业性的地方性的非营利性社会组织。</span>
      </div>
      <div class="content">
        <span class="content-title">第三条</span>
        <span>本团体的宗旨：遵守宪法、法律、法规和国家政策，践行社会主义核心价值观，遵守社会道德风尚。高举中国特色社会主义伟大旗帜，坚持以习近平新时代中国特色社会主义思想为指导，全面贯彻习近平法治思想，弘扬伟大建党精神，坚持中国共产党的全面领导，坚决维护党中央权威和集中统一领导；组织会员学习党的路线、方针和政策，遵守并宣传贯彻司法鉴定有关法律法规和政策，恪守司法鉴定职业道德、执业纪律和执业行为规则。贡献于司法鉴定行业发展规划，承担法律授权及业务主管机关委托的工作职能并履行相关工作职责。维护行业公平竞争，保障会员合法权益，监督和管理司法鉴定机构、司法鉴定人执业活动，调解会员执业活动中的重大纠纷。遵守司法鉴定各项规定要求，提高司法鉴定质量和社会公信力，促进我市司法鉴定事业高质量发展。</span>
      </div>
      <div class="content">
        <span class="content-title">第四条</span>
        <span>本团体坚持中国共产党的全面领导，根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件。</span>
      </div>
      <div class="content">
        <span class="content-title">第五条</span>
        <span>本团体接受业务主管单位：深圳市司法局；社团登记管理机关：深圳市民政局的业务指导和监督管理。</span>
      </div>
      <div class="content">
        <span class="content-title">第六条</span>
        <span>本团体住所：广东省深圳市。</span>
      </div>
      <div class="general">
        <span>第二章</span>
        <span>业务范围</span>
      </div>
      <div class="content">
        <span class="content-title">第七条</span>
        <span>本团体的业务范围：</span>
      </div>
      <div class="content">
        <span>1、宣传司法鉴定有关的法律、法规、规章、政策和规定，维护司法鉴定行业利益，维护司法鉴定人的合法权益；</span>
      </div>
      <div class="content">
        <span>2、制定行业自律规则，配合司法行政管理部门对全市司法鉴定机构和司法鉴定人的职业道德和执业纪律进行监督和检查，增强司法鉴定人的自律意识；</span>
      </div>
      <div class="content">
        <span>3、组织、指导各专业委员会、咨询委员会开展司法鉴定专业理论研讨、个案论证和鉴定技术的交流活动，不断提高鉴定质量，编制鉴定流程，制定技术规范，并定期编印司法鉴定工作信息专刊；</span>
      </div>
      <div class="content">
        <span>4、加强与行政管理部门、司法鉴定机构之间的协调沟通，及时向行政管理部门反映司法鉴定行业管理中存在的问题，并提出解决问题的意见和建议；</span>
      </div>
      <div class="content">
        <span>5、协助对司法鉴定机构和司法鉴定人执业活动中违纪违规行为的调查处理；</span>
      </div>
      <div class="content">
        <span>6、办理司法行政管理部门交办的其他工作。</span>
      </div>
      <div class="general">
        <span>第三章</span>
        <span>会员</span>
      </div>
      <div class="content">
        <span class="content-title">第八条</span>
        <span>本团体的会员种类为个人会员和单位会员。</span>
      </div>
      <div class="content">
        <span class="content-title">第九条</span>
        <span>申请加入本会的会员必须具备下列条件：</span>
      </div>
      <div class="content">
        <span>（一）拥护本团体的章程；</span>
      </div>
      <div class="content">
        <span>（二）有加入本团体的意愿；</span>
      </div>
      <div class="content">
        <span>（三）在本团体的业务（学科）领域内具有一定的影响；</span>
      </div>
      <div class="content">
        <span>（四）经司法行政机关核准在本市执业的司法鉴定机构和司法鉴定人，或从事司法鉴定管理工作与具有相关领域专业的人员，开展司法鉴定有关教育、科研等业务的企业或机构。</span>
      </div>

    </div>
    <div v-if="page == 1">
      <div class="content">
        <span class="content-title">第十条</span>
        <span>会员入会的程序是：</span>
      </div>
      <div class="content">
        <span>（一）提交入会申请书；</span>
      </div>
      <div class="content">
        <span>（二）经理事会讨论通过；</span>
      </div>
      <div class="content">
        <span>（三）由理事会或理事会授权秘书处发给会员证；</span>
      </div>
      <div class="content">
        <span>（四）由监事会监督理事会工作和会员入会程序。</span>
      </div>
      <div class="content">
        <span class="content-title">第十一条</span>
        <span>会员享有下列权利：</span>
      </div>
      <div class="content">
        <span>（一）本团体的选举权、被选举权和表决权；</span>
      </div>
      <div class="content">
        <span>（二）参加本团体的活动；</span>
      </div>
      <div class="content">
        <span>（三）获得本团体服务的优先权；</span>
      </div>
      <div class="content">
        <span>（四）对本团体工作的批评建议权和监督权；</span>
      </div>
      <div class="content">
        <span>（五）入会自愿、退会自由；</span>
      </div>
      <div class="content">
        <span>（六）请求本团体维护其与执业相关的合法权益；</span>
      </div>
      <div class="content">
        <span>（七）使用本团体的图书、资料、网络和信息资源；</span>
      </div>
      <div class="content">
        <span>（八）通过本团体向有关部门反映意见；</span>
      </div>
      <div class="content">
        <span>（九）法律法规和本团体规定的其他权利。</span>
      </div>
      <div class="content">
        <span class="content-title">第十二条</span>
        <span>会员履行下列义务：</span>
      </div>
      <div class="content">
        <span>（一）执行本团体的决议；</span>
      </div>
      <div class="content">
        <span>（二）维护本团体合法权益；</span>
      </div>
      <div class="content">
        <span>（三）完成本团体交办的工作；</span>
      </div>
      <div class="content">
        <span>（四）按规定交纳会费；</span>
      </div>
      <div class="content">
        <span>（五）向本团体反映情况，提供有关资料；</span>
      </div>
      <div class="content">
        <span>（六）遵守本团体的章程和规定，依法依规开展鉴定活动； </span>
      </div>
      <div class="content">
        <span>（七）接受本团体的监督和管理；</span>
      </div>
      <div class="content">
        <span>（八）维护行业信誉，维护会员间的团结；</span>
      </div>
      <div class="content">
        <span>（九）法律法规和本会规定的其他义务。</span>
      </div>

    </div>
    <div v-if="page == 2">
      <div class="content">
        <span class="content-title">第十三条</span>
        <span> 会员退会应书面通知本团体，并交回会员证。会员如果1年不交纳会费或不参加本团体活动的，视为自动退会。</span>
      </div>
      <div class="content">
        <span class="content-title">第十四条</span>
        <span> 会员如有严重违反本章程的行为，经理事会或常务理事会表决通过，予以除名。</span>
      </div>
      <div class="general">
        <span>第四章</span>
        <span>组织机构和负责人产生、罢免</span>
      </div>
      <div class="content">
        <span class="content-title">第十五条</span>
        <span>本团体的最高权力机构是：会员代表大会。
          会员代表大会的职权是：</span>
      </div>
      <div class="content">
        <span>（一）制定和修改章程；</span>
      </div>
      <div class="content">
        <span>（二）选举和罢免理事；</span>
      </div>
      <div class="content">
        <span>（三）审议理事会的工作报告和财务报告；</span>
      </div>
      <div class="content">
        <span>（四）决定终止事宜；</span>
      </div>
      <div class="content">
        <span>（五）决定其他重大事宜。</span>
      </div>
      <div class="content">
        <span class="content-title">第十六条</span>
        <span>会员代表大会须有2/3以上的会员代表出席方能召开，其决议须经到会会员代表半数以上表决通过方能生效。</span>
      </div>
      <div class="content">
        <span class="content-title">第十七条</span>
        <span>会员代表大会每届5年。
          因特殊情况需提前或延期换届的，须由理事会表决通过，报业务主管单位审查并经登记管理机关批准同意。但延期换届最长不超过1年。</span>
      </div>
      <div class="content">
        <span class="content-title">第十八条</span>
        <span>理事会是会员代表大会的执行机构，在闭会期间领导本团体开展日常工作，对会员代表大会负责。</span>
      </div>
      <div class="content">
        <span class="content-title">第十九条</span>
        <span>理事会的职权是：</span>
      </div>
      <div class="content">
        <span>（一）执行会员代表大会的决议；</span>
      </div>
      <div class="content">
        <span>（二）选举和罢免理事长（会长）、副理事长（副会长）、秘书长；</span>
      </div>
      <div class="content">
        <span>（三）筹备召开会员代表大会；</span>
      </div>
      <div class="content">
        <span>（四）向会员代表大会报告工作和财务状况；</span>
      </div>
      <div class="content">
        <span>（五）决定会员的吸收和除名；</span>
      </div>
      <div class="content">
        <span>（六）决定设立办事机构、分支机构、代表机构和实体机构；；</span>
      </div>
      <div class="content">
        <span>（七）决定副秘书长、各机构主要负责人的聘任；</span>
      </div>
      <div class="content">
        <span>（八）领导本团体各机构开展工作；</span>
      </div>
      <div class="content">
        <span>（九）制定内部管理制度；</span>
      </div>
      <div class="content">
        <span>（十）决定其他重大事项。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十条</span>
        <span>理事会须有2/3以上理事出席方能召开，其决议须经到会理事2/3以上表决通过方能生效。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十一条</span>
        <span>理事会每年至少召开一次会议；情况特殊的，也可采取通讯形式召开。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十二条</span>
        <span>本团体不设立常务理事会（理事人数较多时，可设立常务理事会）。常务理事会由理事会选举产生，在理事会闭会期间行使第十九条第一、三、五、六、七、八、九项的职权，对理事会负责（常务理事人数不超过理事人数的1/3）。</span>
      </div>



    </div>
    <div v-if="page == 3">
      <div class="content">
        <span class="content-title">第二十三条</span>
        <span>常务理事会须有2/3以上常务理事出席方能召开，其决议须经到会常务理事2/3以上表决通过方能生效。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十四条</span>
        <span>常务理事会至少半年召开一次会议；情况特殊的也可采用通讯形式召开。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十五条</span>
        <span>本团体的理事长（会长）、副理事长（副会长）、秘书长必须具备下列条件：</span>
      </div>
      <div class="content">
        <span>（一）坚持党的路线、方针、政策，政治素质好；</span>
      </div>
      <div class="content">
        <span>（二）在本团体业务领域内有较大影响；</span>
      </div>
      <div class="content">
        <span>（三）理事长（会长）、副理事长（副会长）、秘书长最高任职年龄不超过70周岁，秘书长为专职；</span>
      </div>
      <div class="content">
        <span>（四）身体健康，能坚持正常工作；</span>
      </div>
      <div class="content">
        <span>（五）未受过剥夺政治权利的刑事处罚的；</span>
      </div>
      <div class="content">
        <span>（六）具有完全民事行为能力；</span>
      </div>
      <div class="content">
        <span>（七）从事司法鉴定业务或管理工作满五年，在本市司法鉴定行业内享有较高声望；</span>
      </div>
      <div class="content">
        <span>（八）具有较强的组织能力和协调能力，业务素质优良、业绩显著、办事公正、热心司法鉴定事业。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十六条</span>
        <span>本团体理事长（会长）、副理事长（副会长）、秘书长如超过最高任职年龄的，须经理事会表决通过，报业务主管单位审查并经社团登记管理机关批准同意后，方可任职。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十七条</span>
        <span>本团体理事长（会长）副理事长（副会长）秘书长任期5年。理事长（会长）任期最长不得超过两届。因特殊情况需延长任期的，须经会员代表大会2/3以上会员（或会员代表）表决通过，报业务主管单位审查并经社团登记管理机关批准同意后方可任职。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十八条</span>
        <span>本团理事长（会长）为本团体法定代表人。本团体法定代表人不兼任其他团体的法定代表人。</span>
      </div>
      <div class="content">
        <span class="content-title">第二十九条</span>
        <span>本团体理事长（会长）行使下列职权：</span>
      </div>
      <div class="content">
        <span>（一）召集和主持理事会（或常务理事会）；</span>
      </div>
      <div class="content">
        <span>（二）检查会员代表大会、理事会（或常务理事会）决议的落实情况；</span>
      </div>
      <div class="content">
        <span>（三）代表本团体签署有关重要文件； </span>
      </div>
      <div class="content">
        <span>（四）代表理事会领导本会工作； </span>
      </div>
      <div class="content">
        <span>（五）主持理事会、会长办公会工作； </span>
      </div>
      <div class="content">
        <span>（六）代表本会对外从事职务活动； </span>
      </div>
      <div class="content">
        <span>（七）督促和检查各专业、工作委员会和秘书处执行工作情况。</span>
      </div>

      <div class="content">
        <span class="content-title">第三十条</span>
        <span>本团体秘书长行事下列职权：</span>
      </div>
      <div class="content">
        <span>（一）主持办事机构开展日常工作，组织实施年度工作计划；</span>
      </div>
      <div class="content">
        <span>（二）协调各分支机构、代表机构、实体机构开展工作；</span>
      </div>
      <div class="content">
        <span>（三）提名副秘书长以及各办事机构、分支机构、代表机构和实体机构主要负责人，交理事会或常务理事会决定；</span>
      </div>
      <div class="content">
        <span>（四）决定办事机构、代表机构、实体机构专职工作人员的聘用；</span>
      </div>
      <div class="content">
        <span>（五）处理其他日常事务。</span>
      </div>

    </div>
    <div v-if="page == 4">
      <div class="content">
        <span>本会设立监事会，监事会是本会的监督机构，由监事长、监事组成，监事会由会员代表大会选举产生。监事会行事以下职权：</span>
      </div>
      <div class="content">
        <span>（一）对会员代表大会负责，执行会员代表大会的决定、决议；</span>
      </div>
      <div class="content">
        <span>（二）监督本会各部门运作情况及人员履职情况，对认为不符合规定的决定和事项提出监督意见；对认为不符合本会规定任职条件或履职不到位的人员提出罢免建议；</span>
      </div>
      <div class="content">
        <span>（三）监督本会财务情况；</span>
      </div>
      <div class="content">
        <span>（四）法律法规或会员代表大会授权的其他事项。
          监事会每年至少召开一次会议，由监事长召集。须有三分之二以上的监事出席方可召开监事会，其决议须经出席监事三分之二以上表决通过。</span>
      </div>
      <div class="content">
        <span>监事应当拥护党的领导，遵守法律法规，身体健康，从事司法鉴定业务或管理工作满五年，敢于坚守原则、乗公办事、热爱司法鉴定行业。监事协助监事长做好各项分管工作，完成监事长交办的事项。</span>
      </div>
      <div class="content">
        <span>监事在任期内累计三次不参加监事会相关会议或者不履行监事职责的，免除其职务。</span>
      </div>
      <div class="content">
        <span>理事不得担任监事，监事不得担任专业、工作委员会主任委员、副主任委员及委员。</span>
      </div>
      <div class="general">
        <span>第五章</span>
        <span>资产管理、使用原则</span>
      </div>
      <div class="content">
        <span class="content-title">第三十一条</span>
        <span>本团体经费来源：</span>
      </div>
      <div class="content">
        <span>（一）会费；</span>
      </div>
      <div class="content">
        <span>（二）捐赠；</span>
      </div>
      <div class="content">
        <span>（三）政府资助；</span>
      </div>
      <div class="content">
        <span>（四）在核准的业务范围内开展活动或服务的收入；</span>
      </div>
      <div class="content">
        <span>（五）利息；</span>
      </div>
      <div class="content">
        <span>（六）其他合法收入；</span>
      </div>
      <div class="content">
        <span>（七）政府购买服务</span>
      </div>
      <div class="content">
        <span class="content-title">第三十二条</span>
        <span>本团体按照国家有关规定收取会员会费。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十三条</span>
        <span>本团体经费必须用于本章程规定的业务范围和事业的发展，不得在会员中分配。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十四条</span>
        <span>本团体建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十五条</span>
        <span>本团体配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人员办清交接手续。</span>
      </div>
    </div>
    <div v-if="page == 5">

      <div class="content">
        <span class="content-title">第三十六条</span>
        <span>本团体的资产管理必须执行国家规定的财务管理制度，接受 会员代表大会和财政部门的监督。资产来源属于国家拨款或者社会捐赠、资助的，必须接受审计机关的监督，并将有关情况以适当方式向社会公布。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十七条</span>
        <span>本团体换届或更换法定代表人之前必须接受社团登记管理机关和业务主管单位组织的财务审计。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十八条</span>
        <span>本团体的资产，任何单位、个人不得侵占、私分和挪用。</span>
      </div>
      <div class="content">
        <span class="content-title">第三十九条</span>
        <span>本团体专职工作人员的工资和保险、福利待遇，参照国家对事业单位的有关规定执行。</span>
      </div>
      <div class="general">
        <span>第六章</span>
        <span>党建工作</span>
      </div>

      <div class="content">
        <span class="content-title">第四十条</span>
        <span>本团体坚持中国共产党的领导，执行党的路线、方针和政策，走中国特色社会组织发展之路。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十一条</span>
        <span>本团体根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动（如暂不能单独建立党组织，支持通过联合建立党组织、选派党建工作联络员等方式，在本组织开展党的工作），为党组织的活动提供必要条件。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十二条</span>
        <span>本团体党组织是党在深圳市司法鉴定协会中的战斗堡垒，发挥政治核心作用。基本职能是保证政治方向，团结凝聚群众，推动深圳市司法鉴定协会发展，建设先进文化，服务人才成长，加强党组织自身建设。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十三条</span>
        <span>本团体变更、撤并或注销，党组织应及时向上级党组织报告，并做好党员组织关系转移等相关工作；本会换届选举时，应先征求上级党组织对主要负责人审核意见。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十四条</span>
        <span>本团体为党组织开展活动、做好工作提供必要的场地、人员和经费支持，将党建工作经费纳入管理费用列支，支持党组织建设活动阵地。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十五条</span>
        <span>本团体支持社会组织领导班子与党组织领导班子交叉任职，优先推荐社会组织领导班子中的中共正式党员担任党的组织以及纪检组织领导。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十六条</span>
        <span>本团体支持党组织对社会组织重要事项决策、重要业务活动、大额经费开支、接收大额捐赠、开展涉外活动等提出意见。</span>
      </div>
      <div class="general">
        <span>第七章</span>
        <span>章程的修改程序</span>
      </div>
      <div class="content">
        <span class="content-title">第四十七条</span>
        <span>对本团体章程的修改，须经理事会表决后报会员代表大会审议。</span>
      </div>
      <div class="content">
        <span class="content-title">第四十八条</span>
        <span>本团体修改的章程，须在会员代表大会通过后15日内， 报业务主管单位审查并报社团登记管理机关核准后生效。</span>
      </div>
    </div>
    <div v-if="page == 6">



      <div class="general">
        <span>第八章</span>
        <span>终止程序及终止后的财产处理</span>
      </div>
      <div class="content">
        <span class="content-title">第四十九条</span>
        <span>本团体完成宗旨或自行解散或由于分立、合并等原因需要注销的，由理事会或常务理事会提出终止动议。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十条</span>
        <span>本团体终止动议须经会员代表大会表决通过，报业务主管单位审查同意。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十一条</span>
        <span>本团体终止前，须在业务主管单位及有关机关指导下成立清算组织，清理债权债务，处理善后事宜。清算期间，不开展清算以外的活动。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十二条</span>
        <span>本团体经社团登记管理机关办理注销登记手续后即为终止。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十三条</span>
        <span>本团体终止后的剩余财产，在业务主管单位和登记管理机关的监督下，按照国家有关规定，应移交给同类非营利组织，用于发展与本团体宗旨相关的事业。</span>
      </div>
      <div class="general">
        <span>第九章</span>
        <span>附 则</span>
      </div>
      <div class="content">
        <span class="content-title">第五十四条</span>
        <span>章程经 2024 年 12 月 28 日会员代表大会表决通过。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十五条</span>
        <span>本章程的解释权属本团体的理事会。</span>
      </div>
      <div class="content">
        <span class="content-title">第五十六条</span>
        <span>本章程自登记管理机关核准之日起生效。</span>
      </div>
    </div>
    <div class="but">
      <button type="submit" @click="skip(1)">上一页</button>
      <button type="submit" @click="skip(2)">下一页</button>
      <span>当前为第{{ page + 1 }}页/共7页</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 0,
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    skip(index) {
      if (index == 1) {
        if (this.page == 0) {
          return;
        } else {
          this.page -= 1;
        }
      } else {
        if (this.page == 6) {
          this.$message({
            message: '已经是最后一页了!',
            type: 'warning'
          });
        } else {
          this.page += 1;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
// #ruleDom{
//   width: 100%;
// }
.constitution {
  h2 {
    text-align: center;
    margin-bottom: 56px;
  }

  .general {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;

    span {
      font-size: 28px;
      // color: #00002b;
    }

    span:nth-child(1) {
      margin-right: 40px;
    }
  }

  .content {
    width: 85%;
    margin: 0 auto;
    text-indent: 4em;
    font-family: 'FangSong';

    span {
      // font-weight: 600;
      font-size: 24px;
      line-height: 40px;
    }

    span:nth-child(1) {
      margin-right: 30px;
    }

    .content-title {
      // font-weight: 600;
      font-family: 'Noto Sans SC';
    }
  }

  .but {
    margin-left: 44%;
    margin-top: 40px;

    button {
      margin-right: 20px;
      width: 100px;
      height: 40px;
      background-color: beige;
      border-radius: 6px;
      cursor: pointer;
    }

    button:hover {
      color: cornsilk;
      background-color: rgb(110, 104, 104);
    }
  }
}
</style>